export const TabPanels = ({ children }) => {
  return <ul>{children}</ul>;
};
